/**
 * Dummy data generator for HRIS modules
 * Injects mock data into localStorage for development/testing
 */

const STORAGE_PREFIX = 'onealpha_hris_';
const DUMMY_VERSION = '1.0.6';

const dummyEmployees = [
  {
    id: 'EMP-001',
    name: 'Ahmad Riyandi',
    fullName: 'Ahmad Riyandi',
    department: 'Engineering',
    designation: 'Senior Developer',
    company: 'CBQAGlobal',
  },
  {
    id: 'EMP-002',
    name: 'Siti Nurhaliza',
    fullName: 'Siti Nurhaliza',
    department: 'Finance',
    designation: 'Finance Manager',
    company: 'CBQAGlobal',
  },
  {
    id: 'EMP-003',
    name: 'Budi Santoso',
    fullName: 'Budi Santoso',
    department: 'Sales',
    designation: 'Sales Executive',
    company: 'CBQAGlobal',
  },
  {
    id: 'EMP-004',
    name: 'Rina Wijaya',
    fullName: 'Rina Wijaya',
    department: 'HR',
    designation: 'HR Specialist',
    company: 'CBQAGlobal',
  },
  {
    id: 'EMP-005',
    name: 'Hendra Kusuma',
    fullName: 'Hendra Kusuma',
    department: 'Operations',
    designation: 'Operations Manager',
    company: 'CBQAGlobal',
  },
];

const dummyExpenseClaimTypes = [
  {
    id: 'ECT-001',
    code: 'TRAVEL_AIR',
    name: 'Travel - Air',
    description: 'Airfare and flight expenses',
    status: 'Active',
  },
  {
    id: 'ECT-002',
    code: 'TRAVEL_HOTEL',
    name: 'Travel - Hotel',
    description: 'Hotel accommodation',
    status: 'Active',
  },
  {
    id: 'ECT-003',
    code: 'TRAVEL_TRANSPORT',
    name: 'Travel - Transport',
    description: 'Ground transportation',
    status: 'Active',
  },
  {
    id: 'ECT-004',
    code: 'MEALS',
    name: 'Meals & Entertainment',
    description: 'Meal and client entertainment',
    status: 'Active',
  },
  {
    id: 'ECT-005',
    code: 'OFFICE_SUPPLIES',
    name: 'Office Supplies',
    description: 'Office materials and supplies',
    status: 'Active',
  },
  {
    id: 'ECT-006',
    code: 'COMMUNICATION',
    name: 'Communication',
    description: 'Phone, internet, postal charges',
    status: 'Active',
  },
];

const dummyExpenses = [
  {
    id: 'EXP-2406-001',
    employeeId: 'EMP-001',
    employeeName: 'Ahmad Riyandi',
    expenseDate: '2026-06-15',
    expenseType: 'Travel - Air',
    totalClaimed: 5500000,
    totalSanctioned: 5500000,
    company: 'CBQAGlobal',
    status: 'Approved',
    description: 'Flight to Jakarta for client meeting',
    createdAt: '2026-06-18T10:30:00Z',
    updatedAt: '2026-06-20T14:15:00Z',
    _source: 'local-draft',
  },
  {
    id: 'EXP-2406-002',
    employeeId: 'EMP-002',
    employeeName: 'Siti Nurhaliza',
    expenseDate: '2026-06-16',
    expenseType: 'Travel - Hotel',
    totalClaimed: 2000000,
    totalSanctioned: 1800000,
    company: 'CBQAGlobal',
    status: 'Approved',
    description: 'Hotel accommodation for 3 nights in Surabaya',
    createdAt: '2026-06-17T09:00:00Z',
    updatedAt: '2026-06-19T11:20:00Z',
    _source: 'local-draft',
  },
  {
    id: 'EXP-2406-003',
    employeeId: 'EMP-003',
    employeeName: 'Budi Santoso',
    expenseDate: '2026-06-19',
    expenseType: 'Meals & Entertainment',
    totalClaimed: 850000,
    totalSanctioned: 850000,
    company: 'CBQAGlobal',
    status: 'Submitted',
    description: 'Client dinner meeting at Novotel',
    createdAt: '2026-06-20T15:45:00Z',
    updatedAt: '2026-06-20T15:45:00Z',
    _source: 'local-draft',
  },
];

const employeeAdvances = [
    {
  id: 'EAD-2406-001',
  series: 'HR-EAD-.YYYY.-',
  postingDate: '2026-06-24',
  employeeId: 'EMP-001',
  employeeName: 'Andi Wijaya',
  company: 'Nexora (Demo)',
  purpose: 'Business trip to Jakarta',
  advanceAmount: 2500000,
  advanceAccount: 'Employee Advances - ND',
  modeOfPayment: 'Bank Transfer',
  repayUnclaimedAmountFromSalary: true,
  status: 'Draft',
  createdAt: '2026-06-24T09:00:00Z',
  updatedAt: '2026-06-24T09:00:00Z',
  _source: 'local-draft',
},
];

const dummyDepartments = [
  {
    id: "DEP-001",
    departmentName: "Finance Department",
    departmentCode: "FIN",
    parentDepartment: "",
    company: "PT CBQA GLOBAL INDONESIA",
    managerName: "Ida Simaputri",
    status: "Active",

    jobTitles: [
      {
        id: "JT-001",
        title: "Finance Manager",
        employeeCount: 1,
      },
      {
        id: "JT-002",
        title: "Finance Staff",
        employeeCount: 4,
      },
      {
        id: "JT-003",
        title: "Accounting Staff",
        employeeCount: 2,
      },
    ],
  },

  {
    id: "DEP-002",
    departmentName: "HRGA Department",
    departmentCode: "HRGA",
    parentDepartment: "Service Division",
    company: "PT CBQA GLOBAL INDONESIA",
    managerName: "Mochammad Perbowo",
    status: "Active",

    jobTitles: [
      {
        id: "JT-004",
        title: "HR Manager",
        employeeCount: 1,
      },
      {
        id: "JT-005",
        title: "HR Staff",
        employeeCount: 3,
      },
      {
        id: "JT-006",
        title: "GA Staff",
        employeeCount: 2,
      },
    ],
  },
];



/**
 * Centralized dummy data registry
 * Tambah modul baru cukup tambahkan di sini.
 */
export const dummyData = {
  employees: dummyEmployees,

  expenses: dummyExpenses,

  'expense-claim-types': dummyExpenseClaimTypes,

  'employee-advances': employeeAdvances,

  departments: dummyDepartments,

  designations: [],

  payroll: [],

  leaves: [],

  recruitment: [],

  performance: [],
};

export const initializeDummyData = () => {
  try {
    const currentVersion = localStorage.getItem(
      'onealpha_hris_dummy_version'
    );

    // have already injected the same version
    if (currentVersion === DUMMY_VERSION) {
      return;
    }

Object.entries(dummyData).forEach(([key, value]) => {
  const storageKey = `${STORAGE_PREFIX}${key}`;

  const existing = JSON.parse(
    localStorage.getItem(storageKey) || 'null'
  );

  if (
    currentVersion !== DUMMY_VERSION ||
    !existing ||
    existing.length === 0
  ) {
    localStorage.setItem(
      storageKey,
      JSON.stringify(value)
    );
  }
});

    localStorage.setItem(
      'onealpha_hris_dummy_version',
      DUMMY_VERSION
    );

    console.log(
      `Dummy data initialized v${DUMMY_VERSION}`
    );
  } catch (error) {
    console.error(error);
  }
};

/**
* Auto initialize
 */
if (typeof window !== 'undefined') {
  initializeDummyData();
  console.log('HRIS dummy data module loaded');
}

/**
 * Clear all dummy data
 */
export const clearDummyData = () => {
  try {
    Object.keys(dummyData).forEach((key) => {
      localStorage.removeItem(
        `${STORAGE_PREFIX}${key}`
      );
    });

    localStorage.removeItem(
      'onealpha_hris_dummy_version'
    );

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

/**
 * Get dummy data statistics
 */
export const getDummyDataInfo = () =>
  Object.fromEntries(
    Object.entries(dummyData).map(([key, value]) => [
      key,
      value.length,
    ])
  );